import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ExtensionPoints } from "abweb/utils/plugins/ExtensionPoints";
export class AbMarkdownExtensions {}

// Extensions to the built-in link type in the markdown editor.
// Always of the syntax /[text](URL)/, where the URL protocol distinguishes the kind of link
_defineProperty(AbMarkdownExtensions, "markdownLinkExtensions", ExtensionPoints.syncKeyedValues(x => x.protocol));
_defineProperty(AbMarkdownExtensions, "markdownPersonExtension", ExtensionPoints.syncSingleValue());
_defineProperty(AbMarkdownExtensions, "markdownInputFieldExtension", ExtensionPoints.syncSingleValue());
_defineProperty(AbMarkdownExtensions, "markdownParamFieldExtension", ExtensionPoints.syncSingleValue());
_defineProperty(AbMarkdownExtensions, "markdownAbstractFieldExtension", ExtensionPoints.syncSingleValue());
_defineProperty(AbMarkdownExtensions, "markdownPersistImageExtension", ExtensionPoints.syncSingleValue());
_defineProperty(AbMarkdownExtensions, "markdownCodeEditorExtensions", ExtensionPoints.syncKeyedValues(x => x.language)); // Markdown syntax is always /[<displayName>](person:<id>)/  That way, other markdown renderers will show a link.
// Markdown syntax is always /[<displayName>](input/param:<field_info>)/  That way, other markdown renderers will show a link.
//# sourceMappingURL=AbMarkdownExtensions.js.map
